import React from "react";
import { Star, Phone } from "lucide-react";
import SectionLabel from "@/components/SectionLabel";
import EmergencyBanner from "@/components/EmergencyBanner";
import { PRIMARY_PHONE, SITE } from "@/lib/site";

const REVIEWS = [
  { name: "Liam J.", role: "Local driver, Sale VIC", quote: "Really cheap price and reliable, highly recommended.", stars: 5 },
  { name: "Emily Brown", role: "Customer, Melbourne", quote: "Great business, cheap price, very helpful — saved my night.", stars: 5 },
  { name: "David Wilson", role: "Customer, Albion", quote: "Arrived quickly and very professional, top job.", stars: 5 },
  { name: "John Smith", role: "Customer, Geelong", quote: "Quoted fairly over the phone and stuck to the price. Driver was friendly and got my car loaded carefully on the flatbed.", stars: 5 },
  { name: "Sophie M.", role: "Caravan owner, Bendigo", quote: "Needed our caravan transported across the state — handled with great care and at a price the others couldn't match.", stars: 4 },
  { name: "Marcus T.", role: "Fleet manager, Pakenham", quote: "We use Vic Wide for our box-truck moves between depots. Reliable, fast and properly insured.", stars: 5 },
  { name: "Hannah K.", role: "Driver, Frankston", quote: "Battery died in a car park late at night. They jump-started it on the spot — no tow needed. Saved me hundreds.", stars: 5 },
  { name: "Robert P.", role: "Boat owner, Mornington", quote: "Boat transport from the marina to home was effortless. Strapped down properly and arrived without a scratch.", stars: 5 },
];

const Testimonials = () => (
  <div data-testid="testimonials-page">
    <section className="bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-16 lg:pt-24 pb-10">
        <SectionLabel>Reviews</SectionLabel>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-slate-900 leading-[1.05] max-w-3xl">
          Real Victorians. Real situations. Real reviews.
        </h1>
        <div className="mt-6 flex items-center gap-4">
          <div className="flex items-center gap-1 text-amber-500">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} className="h-5 w-5 fill-current" />
            ))}
          </div>
          <p className="text-slate-700">
            <span className="font-num font-extrabold text-slate-900">{SITE.rating}</span>{" "}
            average rating from{" "}
            <span className="font-num font-extrabold text-slate-900">{SITE.reviewsCount}</span>{" "}
            customers.
          </p>
        </div>
      </div>
    </section>

    <section className="pb-20 bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {REVIEWS.map((r, i) => (
          <figure
            key={i}
            data-testid={`review-card-${i}`}
            className="rounded-2xl border border-slate-200 p-7 bg-slate-50 hover:bg-white hover:-translate-y-1 hover:shadow-lg transition-all"
          >
            <div className="flex gap-1 text-amber-500">
              {Array.from({ length: 5 }).map((_, k) => (
                <Star
                  key={k}
                  className={`h-4 w-4 ${k < r.stars ? "fill-current" : "opacity-30"}`}
                />
              ))}
            </div>
            <blockquote className="mt-5 font-display text-lg font-bold text-slate-900 leading-snug">
              "{r.quote}"
            </blockquote>
            <figcaption className="mt-6 flex items-center gap-3">
              <div className="grid h-10 w-10 place-items-center rounded-full bg-[var(--color-primary)] text-white font-display font-bold">
                {r.name.charAt(0)}
              </div>
              <div>
                <p className="font-bold text-slate-900 text-sm">{r.name}</p>
                <p className="text-xs text-slate-500">{r.role}</p>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>

      <div className="mt-16 text-center">
        <a
          href={`tel:${PRIMARY_PHONE.tel}`}
          data-testid="testimonials-call-button"
          className="inline-flex items-center gap-3 rounded-full bg-[var(--color-secondary)] px-6 py-4 font-display font-extrabold text-white hover:-translate-y-0.5 hover:shadow-xl transition-all"
        >
          <Phone className="h-5 w-5" />
          Join 19+ happy customers — call {PRIMARY_PHONE.number}
        </a>
      </div>
    </section>

    <EmergencyBanner />
  </div>
);

export default Testimonials;
